import React, { PureComponent, CSSProperties } from 'react';
import { UpdateExperiments } from './SharedTypes';

const divStyle: CSSProperties = {
  border: '5px solid pink',
  position: 'fixed',
  bottom: 0,
  right: 0,
  padding: '10px 15px',
  borderRadius: '20px 0 0 2px',
  borderStyle: 'solid',
  borderWidth: '1px 0 0 1px',
  cursor: 'help',
  zIndex: 999999999999,
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  textAlign: 'left',
  maxHeight: '100%',
  overflow: 'auto'
};

const experimentGroup = {
  borderBottom: 'solid 1px black',
  paddingTop: '15px'
};

const radioWidthOverride: CSSProperties = {
  width: '1em',
  clip: 'inherit',
  height: '1em',
  position: 'inherit'
};

type ownProps = typeof Debugger.defaultProps & {
  environment: string;
  experiments?: {};
  updateExperiment?: UpdateExperiments;
};

type ownState = {
  showExperiments: boolean;
};

export default class Debugger extends PureComponent<ownProps, ownState> {
  state = {
    showExperiments: true
  };

  static defaultProps = {
    experiments: {},
    updateExperiment: () => {}
  };

  /* eslint-disable react/destructuring-assignment */
  updateBucket = (experimentName, bucketName, experimentState) => {
    const { updateExperiment } = this.props;
    const newState = {
      ...experimentState,
      [experimentName]: {
        ...experimentState[experimentName],
        assignedBucket: bucketName
      }
    };

    updateExperiment(experimentName, newState);
  };

  showHideExperiments = () => {
    this.setState(state => ({
      showExperiments: !state.showExperiments
    }));
  };

  updateState = state => this.setState(state);

  render() {
    const { environment, experiments } = this.props;
    const { showExperiments } = this.state;

    return environment === 'production' ? null : (
      <div style={divStyle}>
        <button
          type="button"
          style={{ textAlign: 'center' }}
          onClick={() => this.showHideExperiments()}
        >
          Experiments
        </button>
        {showExperiments && (
          <>
            {Object.keys(experiments).map(experimentName => (
              <div key={experimentName} style={experimentGroup}>
                <b>{experimentName}</b>
                {(experiments[experimentName].buckets || []).sort().map(bucket => {
                  const bucketKey = `${experimentName}-${bucket}`;
                  return (
                    <div key={bucketKey}>
                      <label htmlFor={bucketKey}>
                        <input
                          style={radioWidthOverride}
                          type="radio"
                          name={bucketKey}
                          id={bucketKey}
                          value={bucket}
                          onChange={() =>
                            this.updateBucket(experimentName, bucket, experiments)
                          }
                          checked={
                            bucket ===
                            experiments[experimentName].assignedBucket
                          }
                        />
                        {bucket}
                      </label>
                    </div>
                  );
                })}
              </div>
            ))}
          </>
        )}
      </div>
    );
  }
}
